import { useQuery } from '@tanstack/react-query';
import { useAuthorizedAxios } from '../../../core/hooks';
import { isValidCustomerId } from '../../../customers';
import { getL3Services } from '../../api';
import { L3ServicesHttpQuery } from '../../config';
import { L3ServiceViewModel, mapL3ServicesApiToViewModel } from '../../model';

export interface L3ServicesApiGetHookResult {
  services: L3ServiceViewModel[] | null;
  isFetched: boolean;
  isFetching: boolean;
}

export const useL3ServicesApiGet = (customerId: number | null): L3ServicesApiGetHookResult => {
  const axios = useAuthorizedAxios();
  const { data, isFetched, isFetching } = useQuery({
    queryKey: [L3ServicesHttpQuery['GetL3Services'].key, customerId],
    queryFn: async () => {
      if (customerId === null) {
        return null;
      } else {
        const l3Services = await getL3Services(axios, { customerId });
        return mapL3ServicesApiToViewModel(l3Services);
      }
    },
    enabled: isValidCustomerId(customerId),
    gcTime: 30000,
    staleTime: 1000,
    structuralSharing: false
  });
  
  return {
    services: data || null,
    isFetched,
    isFetching
  };
};